export default class PillsLists {
    static isLogged = function() {
        try{
            if (sessionStorage.getItem("user")) {
                if (sessionStorage.getItem("user_hash") == this.generateHash(sessionStorage.getItem("user_id"))){
                    return true
                } else {
                    sessionStorage.clear()
                    return false
                }
            }

            return false
        }
        catch(e){
            console.log(e)

            return false
        }
    }

    static generateHash = function(s){
        let texto = String(s)
        return texto.split("").reduce(function(a,b){a=((a<<5)-a)+b.charCodeAt(0);return a&a},0);
    }

    //Use this function in order to update the pending and completed lists after server fetch
    static updateAssignedPillsLists = function(myPills){
        let pendingList = []
        let completedList = []
        myPills.forEach(pill => {
            if (pill.assigned.done === false) {
                pendingList.push(pill)
            }

            if (pill.assigned.done === true) {
                completedList.push(pill)
            }
        });

        return [pendingList, completedList]
    }

}